import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface WhatsAppStatus {
  enabled: boolean;
  connected: boolean;
  connection: 'idle' | 'connecting' | 'open' | 'close';
  hasQr: boolean;
  qr?: string;
  lastDisconnectCode?: number;
  stoppedReason?: string;
  reconnectionAttempts: number;
}

export interface WhatsAppMessageStatus {
  messageId: string;
  jid: string;
  status:
    | 'pending'
    | 'server_ack'
    | 'delivered'
    | 'read'
    | 'played'
    | 'error'
    | 'unknown';
  rawStatus?: number;
  error?: string;
  createdAt: string;
  updatedAt: string;
  deliveredAt?: string;
  readAt?: string;
  playedAt?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WhatsAppService {
  constructor(private apiService: ApiService) {}

  getStatus(): Promise<WhatsAppStatus> {
    return this.apiService.request<WhatsAppStatus>('/whatsapp/status', 'GET');
  }

  start(): Promise<WhatsAppStatus> {
    return this.apiService.request<WhatsAppStatus>('/whatsapp/start', 'POST');
  }

  getMessages(limit = 25): Promise<WhatsAppMessageStatus[]> {
    return this.apiService.request<WhatsAppMessageStatus[]>(
      `/whatsapp/messages?limit=${limit}`,
      'GET',
    );
  }

  getMessage(messageId: string): Promise<WhatsAppMessageStatus> {
    return this.apiService.request<WhatsAppMessageStatus>(
      `/whatsapp/messages/${messageId}`,
      'GET',
    );
  }
}
